'use es6';

import I18n from 'I18n';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import VizExButton from 'visitor-ui-component-library/button/VizExButton';
import VizExLoadingButton from 'visitor-ui-component-library/button/VizExLoadingButton';
import SVGSend from 'visitor-ui-component-library-icons/icons/SVGSend';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import { SLINKY, OLAF } from 'visitor-ui-component-library/constants/WidgetColors';
import VizExInput from 'visitor-ui-component-library/input/VizExInput';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledVizExButton = styled(VizExButton).withConfig({
  displayName: "EmailCaptureInput__StyledVizExButton",
  componentId: "in9s5f-0"
})(["padding:0;width:100% !important;height:100%;border-radius:50%;"]);
const LoadingButtonContainer = styled.div.withConfig({
  displayName: "EmailCaptureInput__LoadingButtonContainer",
  componentId: "in9s5f-1"
})(["margin:4px 4px 4px 0;width:30px;height:24px;"]);
const propTypes = {
  disabled: PropTypes.bool,
  locale: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  submissionState: PropTypes.oneOf(['ready', 'submitting', 'done']),
  value: PropTypes.string
};
const EmailCaptureInput = ({
  disabled,
  value,
  onChange,
  onKeyPress,
  onSubmit,
  locale,
  submissionState
}) => {
  return /*#__PURE__*/_jsx(VizExInput, {
    "aria-label": I18n.text('conversations-visitor-message-history.email-capture.placeholderText', {
      locale
    }),
    value: value,
    placeholder: I18n.text('conversations-visitor-message-history.email-capture.placeholderText', {
      locale
    }),
    "data-test-id": "email-capture-input",
    onChange: onChange,
    onKeyPress: onKeyPress,
    suffix: /*#__PURE__*/_jsx(LoadingButtonContainer, {
      children: /*#__PURE__*/_jsx(VizExLoadingButton, {
        currentState: submissionState,
        onClick: onSubmit,
        disabled: disabled,
        "aria-label": I18n.text('conversations-visitor-message-history.email-capture.submitEmailAddress', {
          locale
        }),
        "data-test-id": "email-capture-submit-button",
        Button: StyledVizExButton,
        children: /*#__PURE__*/_jsx(VizExIcon, {
          icon: /*#__PURE__*/_jsx(SVGSend, {
            color: disabled ? SLINKY : OLAF
          })
        })
      })
    })
  });
};
EmailCaptureInput.displayName = 'EmailCaptureInput';
EmailCaptureInput.propTypes = propTypes;
export default EmailCaptureInput;